import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "info-cards",
  class InfoCards extends WYATTElement {
    connectedCallback() {
      const ctas = this.querySelectorAll("a");

      if (ctas.length !== 1) {
        return;
      }

      this.style.cursor = "pointer";

      // Users often try to click anywhere on the block—not just the CTA.
      // To make the experience smoother, we simulate a click on the CTA
      // if there's exactly one link present in the info card.
      this.addEventListener("click", () => ctas[0].click());
    }
  },
);
